/* eslint-disable react/require-default-props */
import React, { HTMLProps } from 'react';

export type MentionProps = {
  username: string,
  disabled?: boolean,
  className?: string,
  userId?: string,
  mentionId?: string,
} & HTMLProps<HTMLSpanElement>;

const Mention: React.FC<MentionProps> = ({
  username,
  disabled = false,
  className = '',
  mentionId = '',
  userId = '',
  ...rest
}) => {
  const styles = disabled ? 'text-kat-tarpon bg-kat-seattle' : 'text-kat-eastern bg-kat-zircon';
  return (
    <span
      data-mentionid={mentionId}
      data-mention-userid={userId}
      data-mention-username={username}
      {...rest}
      className={`${styles} rounded-full px-[4px] pb-[2px] ${className}`}
    >
      {`@${username}`}
    </span>
  );
};

export default Mention;
